/* ===========================================================================
 * NUVIK · header behaviour
 * ---------------------------------------------------------------------------
 * Registered against the shared section lifecycle so it initialises on first
 * page load AND on shopify:section:load, and tears down on unload.
 *
 * Previously inline. Shopify's editor does not re-run a section's page-load
 * JavaScript after replacing its HTML, so the inline version went inert after a
 * merchant changed a header setting.
 *
 * The announcement rotator timer and the page-level menu-open lock are both
 * released on unload - a re-render while the drawer is open would otherwise
 * leave <html> permanently scroll-locked.
 * =========================================================================== */
(function () {
  'use strict';

  function readConfig(root) {
    var el = root.querySelector('[data-nvk-header-config]');
    if (!el) return { announcementSpeed: 5000 };
    try { return JSON.parse(el.textContent); }
    catch (err) { return { announcementSpeed: 5000 }; }
  }

  function init(root, ctx) {
    var cfg = readConfig(root);

var openButtons = root.querySelectorAll('[data-nuvik-open-menu]');
    var closeButtons = root.querySelectorAll('[data-nuvik-close-menu]');
    var drawer = root.querySelector('.nuvik-header__drawer');
    var drawerLinks = root.querySelectorAll('.nuvik-header__drawer a:not([data-nuvik-cart-trigger])');
    var announcementItems = root.querySelectorAll('[data-announcement-item]');
    var cartTriggers = root.querySelectorAll('[data-nuvik-cart-trigger]');
    var activeAnnouncement = 0;
    var announcementInterval = null;

    function setExpanded(value) {
      openButtons.forEach(function (button) {
        button.setAttribute('aria-expanded', value ? 'true' : 'false');
      });

      if (drawer) {
        drawer.setAttribute('aria-hidden', value ? 'false' : 'true');
      }
    }

    function openMenu() {
      root.classList.add('is-open');
      document.documentElement.classList.add('nuvik-menu-open');
      setExpanded(true);
    }

    function closeMenu() {
      root.classList.remove('is-open');
      document.documentElement.classList.remove('nuvik-menu-open');
      setExpanded(false);
    }

    function updateScrollState() {
      if (window.scrollY > 8) {
        root.classList.add('is-scrolled');
      } else {
        root.classList.remove('is-scrolled');
      }
    }

    openButtons.forEach(function (button) {
      button.addEventListener('click', openMenu, { signal: ctx.signal });
    });

    closeButtons.forEach(function (button) {
      button.addEventListener('click', closeMenu, { signal: ctx.signal });
    });

    drawerLinks.forEach(function (link) {
      link.addEventListener('click', closeMenu, { signal: ctx.signal });
    });

    cartTriggers.forEach(function (trigger) {
      trigger.addEventListener('click', function (event) {
        var cartDrawer = document.querySelector('cart-drawer');

        if (!cartDrawer || typeof cartDrawer.open !== 'function') {
          return;
        }

        event.preventDefault();
        closeMenu();
        cartDrawer.open(trigger);
      }, { signal: ctx.signal });
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeMenu();
    }, { signal: ctx.signal });

    window.addEventListener('scroll', updateScrollState, { passive: true, signal: ctx.signal });
    updateScrollState();

    if (announcementItems.length > 1) {
      announcementInterval = setInterval(function () {
        announcementItems[activeAnnouncement].classList.remove('is-active');
        activeAnnouncement = (activeAnnouncement + 1) % announcementItems.length;
        announcementItems[activeAnnouncement].classList.add('is-active');
      }, cfg.announcementSpeed);
    }

    ctx.onCleanup(function () {
      if (announcementInterval) clearInterval(announcementInterval);
      document.documentElement.classList.remove('nuvik-menu-open');
    });
  }

  function destroy() {
    document.documentElement.classList.remove('nuvik-menu-open');
  }

  function boot() {
    if (!window.NuvikSections) return;
    window.NuvikSections.register('headerhomemade', { init: init, destroy: destroy });
  }

  if (window.NuvikSections) boot();
  else document.addEventListener('DOMContentLoaded', boot);
})();
